<script>
export default {
    name: 'IconProgression'
}
</script>
<template>
    <svg
        class="base-icon icon-progression"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8 52h48v4H8v-4zm8-12h6v8h-6v-8zm13-8h6v16h-6V32zm19-8v24h-6V24h6zm3-16v12.5h-3.051v-6.74L37.5 24l-8-8L13 32l-2.5-2.5 19-18.5 8 8 8.01-7.656h-6.798V8H51z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
